import { CssBaseline, ThemeProvider } from '@mui/material';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import React from 'react';
import ReactDOM from 'react-dom/client';
import theme from './theme';
import './i18n';
import { AppRouter } from 'app/core';


const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <StyledThemeProvider theme={theme}>
        <CssBaseline />
        <AppRouter />
      </StyledThemeProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
